import { BookingConfirmation } from "@/api/types";
import { checkoutBooking } from "@/utils/stripe";

export function buildCheckoutOrigin(): string {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.origin;
}

export function bookingRequiresPayment(
  confirmation: BookingConfirmation
): boolean {
  if (typeof confirmation.requiresPayment === "boolean") {
    return confirmation.requiresPayment;
  }
  return !!(confirmation.stripeCustomerId && confirmation.checkoutUrl);
}

export async function completePaidBookingCheckout(
  confirmation: BookingConfirmation,
  shopId: string
): Promise<boolean> {
  const { bookingId, stripeCustomerId, checkoutUrl } = confirmation;

  if (!bookingRequiresPayment(confirmation) && !stripeCustomerId) {
    return false;
  }

  // Prefer instant redirect when create already prepared Checkout
  if (checkoutUrl) {
    window.location.href = checkoutUrl;
    return true;
  }

  if (!stripeCustomerId) {
    return false;
  }

  await checkoutBooking({
    bookingId,
    stripeCustomerId,
    shopId
  });
  return true;
}
